/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActionTypes } from './action';
import { IDeliveryByServiceRes } from "./types";


const initialState: IDeliveryByServiceRes = {
    items: [],
    totalCount: 0,
    optionList:[]


};

const deliveryByServiceReducers = (state: IDeliveryByServiceRes = initialState, action): IDeliveryByServiceRes => {
  switch (action?.type) {
    case ActionTypes.DELIVERY_BY_SERVICE_LIST:{
      const optionList = action?.payload?.items?.map((item: any, index: any)=>{
        return{
          value: item.id,
          label: item.name,
        }
      })
      return {
        ...state,
        ...action?.payload,
        optionList: optionList,
      };

    }
    case ActionTypes.ADD_DELIVERY_BY_SERVICE:{
      const items = [];
      items.push(action?.payload);
      state?.items?.map((item, index)=>{
        items.push(item);
      })
      const totalCount = state?.totalCount + 1;
      return {
        ...state,
        items: items,
        totalCount: totalCount,
      };
    }
    case ActionTypes.UPDATE_DELIVERY_BY_SERVICE:{
      const updatedList = state?.items.map(item =>
        item.id === action?.payload.id ? action?.payload : item
      );
      return {
        ...state,
        items: updatedList,
      };
    }
    case ActionTypes.DELETE_DELIVERY_BY_SERVICE:{
      const updatedList = state.items.filter(item => item.id !== action.payload.id);
      const totalCount = state?.totalCount - 1;
      return {
        ...state,
        items: updatedList,
        totalCount: totalCount
      };
    }
    case ActionTypes.ADMIN_LOGOUT:{
      return initialState
    }
    default:
      return state;
  }
};

export default deliveryByServiceReducers;
